export default __webpack_public_path__ + "static/Failoni-1c9aa77918ef690e9998e2b68398fb77.jpg";